@if (tagsData() && tagsData().length) {
  <app-horizontal-divider [noBottomMargin]="true"></app-horizontal-divider>
  <div class="item-related" [class.no-bottom-padding]="noBottomPadding()">
    <div class="item-tag-title">{{ 'Related items' | translate }}</div>
    @for (item of tagsData(); track item.contentType) {
      <div class="item-tag-content-type">{{ item.contentType | translate }}</div>
      <div class="item-related-tags">
        @for (tag of item.relatedTags; track tag.id) {
          <app-tag-item
            [tag]="tag"
            [tagUrl]="tag.url | addFr"
            [tagTitle]="tag.name"></app-tag-item>
        }
      </div>
    }
  </div>
}
